import { sessionService } from '@/providers/services/auth/session';
import {Vue} from 'vue-property-decorator';

export class LibrarySettingsSerializer  extends Vue {

    public static INSTANCE = new LibrarySettingsSerializer ();

    static get instance() {
        return this.INSTANCE;
    }

    public serializeLibraryList(payload: any) {
        return payload ? payload.libraries : [];
    }

    public serializeLibraryListTenantOpen(payload: any) {
        const allLibrary = payload ? payload.libraries : [];
        const tenenatID = this.$access.getTenantId();
        const library: any = {
            tenantLibrary: [],
            openLibrary: [],
        };
        const tenantLibrary = [];
        const openLibrary = [];
        for (const iterator of allLibrary) {
            if (iterator.tenant === tenenatID) {
                library.tenantLibrary.push(iterator);
            } else {
                library.openLibrary.push(iterator);
            }
        }

        return library;
    }

}

export const librarySettingsSerializer  = LibrarySettingsSerializer .instance;
